/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AzureRestorePointData } from '../models/AzureRestorePointData';
import { CloudSnapshotsPerVolume } from '../models/CloudSnapshotsPerVolume';

export class ListCloudSnapshotsResponse {
  /**
  * Volume-level snapshots (AWS EBS). Empty for Azure resources.
  */
  'snapshotsPerVolume'?: Array<CloudSnapshotsPerVolume>;
  /**
  * VM-level restore points (Azure). Empty for AWS resources.
  */
  'restorePoints'?: Array<AzureRestorePointData>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "snapshotsPerVolume",
      "baseName": "snapshotsPerVolume",
      "type": "Array<CloudSnapshotsPerVolume>",
      "format": ""
    },
    {
      "name": "restorePoints",
      "baseName": "restorePoints",
      "type": "Array<AzureRestorePointData>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListCloudSnapshotsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

